// Risk tag on a Due Diligence chat suggestion chip. Mirrors the backend's
// SuggestionRisk (backend/src/Domain/Services/DueDiligenceQA/DueDiligenceSuggestionsService.ts) —
// kept as a separate frontend copy rather than importing across the backend/frontend boundary.
// 'neutral' is UI-only (MiniChatWidget follow-up chips, which carry no LLM-assigned risk) —
// the backend's SuggestionRisk never produces it.
import { TONE } from './tokens'

export const SUGGESTION_RISK = {
  red: TONE.red,
  amber: TONE.amber,
  default: 'default',
  neutral: TONE.neutral,
} as const

export const SUGGESTION_RISK_VALUES = [
  SUGGESTION_RISK.red,
  SUGGESTION_RISK.amber,
  SUGGESTION_RISK.default,
  SUGGESTION_RISK.neutral,
] as const

export type SuggestionRisk = (typeof SUGGESTION_RISK_VALUES)[number]
